export const ANALYTICS_APPT_SAVE_AMENDS = 'amend appt:Save amends to appointment';
